module.exports = __webpack_public_path__ + "static/media/aboutus.fe7d015f.svg";